// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__zQ0lB","spin":"Spinner_spin__rm97J"};